import { Component, OnInit } from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';

@Component({
  selector: 'cf-itsme-login-bloc',
  templateUrl: './itsme-login-bloc.component.html',
  styleUrls: ['./itsme-login-bloc.component.scss']
})
export class ItsmeLoginBlocComponent implements OnInit {

  constructor(
    private oauthService: OAuthService,

  ) { }

  ngOnInit(): void {
  }

  onClick() {
    this.oauthService.initLoginFlow();
  }
}
